import * as React from "react";
import {
  IXGUIFieldBase,
  TOnChange,
} from "../../../utils/interfaces/gui/fields.interfaces";

import { UNITS } from "../../../utils/constants/gui/units";
import {
  Button,
  Divider,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { TUnit } from "../../../utils/types/gui/field.types";

const compareProps = (prevProps: any, nextProps: any) => {
  // return isEqual(prevProps, nextProps);
  return prevProps.currentValue === nextProps.currentValue;
};

interface XGUISizingFieldProps extends IXGUIFieldBase {
  onChange: TOnChange<string>;
  currentValue: string;
}

const XGUISizingField: React.FC<XGUISizingFieldProps> = React.memo(
  ({ field, currentValue, onChange }) => {
    console.log("CV =>", currentValue);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const bp = useBreakpoint();

    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const value = currentValue ?? field.defaultValue;

    let currentUnit = value ? (value.replace(/[0-9]/g, "") as TUnit) : "px";

    const [unit, setUnit] = React.useState<TUnit>(currentUnit);

    const id = `XGUI-FIELD-${field.name}`;

    const setValue = (_value: string) => {
      console.log("SETVALUE/VALUE =>", _value);

      if (_value) {
        const _unit = _value.replace(/[0-9]/gi, "") as TUnit;

        console.log("SETVALUE/UNIT =>", _unit);

        setUnit(UNITS.includes(_unit) ? _unit : "px");

        onChange(_value, field.name, bp);
      }
    };

    React.useEffect(() => {
      if (!UNITS.includes(currentUnit) && value) {
        const amount = value.replace(/[^0-9]/g, "");

        setUnit("px");

        onChange(amount + "px", field.name, bp);
      }
    }, [currentUnit]);

    return (
      <React.Fragment>
        <Stack
          className="XGUIFieldOption"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography component="label" htmlFor={id} width="40%">
            {field.label}
          </Typography>
          <TextField
            id={id}
            sx={{ ml: 1 }}
            fullWidth
            hiddenLabel
            size="small"
            type="number"
            placeholder={field.placeholder ?? field.label}
            value={value && parseInt(value.replace(/[^0-9]/gi, "") ?? "0")}
            onChange={(e) => {
              if (unit === "auto") {
                setValue(unit);
              } else {
                setValue(e.target.value.replace(/[^0-9]/gi, "") + unit);
              }
            }}
            InputProps={{
              endAdornment: (
                <>
                  <Button
                    id={`XGUIFieldOption-Btn-${name}`}
                    aria-controls={
                      open ? `XGUIFieldOption-Menu-${name}` : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    color="inherit"
                  >
                    {unit}
                  </Button>
                  <Menu
                    id={`XGUIFieldOption-Menu-${name}`}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": `XGUIFieldOption-Btn-${name}`,
                    }}
                    sx={{
                      ".MuiList-root": {
                        p: 0,

                        ".MuiButtonBase-root": {
                          fontSize: 10,
                          px: 1,
                          fontWeight: 600,
                          justifyContent: "center",
                        },
                      },
                    }}
                  >
                    {UNITS.map((_unit) => {
                      return (
                        <MenuItem
                          key={_unit}
                          onClick={() => {
                            if (!UNITS.includes(_unit)) return;

                            setUnit(() => {
                              if (_unit === "auto") {
                                setValue(_unit);
                              } else {
                                const _value = (value ?? "0").replace(
                                  /[^0-9]/gi,
                                  ""
                                );

                                console.log("UNIT =>", _unit);

                                console.log(
                                  "VALUE =>",
                                  (value ?? "0").replace(/[^0-9]/gi, "")
                                );

                                console.log("VALUE+UNIT =>", _value + _unit);

                                if (value) setValue(_value + _unit);
                              }

                              return _unit;
                            });
                            handleClose();
                          }}
                        >
                          {_unit}
                        </MenuItem>
                      );
                    })}
                  </Menu>
                </>
              ),
            }}
          />
        </Stack>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 1 }} />
      </React.Fragment>
    );
  },
  compareProps
);

export default XGUISizingField;
